import React, { useEffect } from 'react';
import { Downgraded, useState } from '@hookstate/core';
import { Box, Divider, CircularProgress } from '@mui/material';
import { useAuthState } from '../../stores/authStore';
import { useEventState } from '../../stores/eventStore';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import Helper from '../../utility/helper';
import { FULL_PERMISSION, VIEW_PERMISSION, REQUEST_STATUS_LIST } from '../../constants/Constant';
import { NO_ACCESS_PERMISSION } from '../../constants/Constant';
import { isEmpty } from 'lodash-es';
import StyledTableRow from '../styledTable/styledTableRow';
import StyledTableCell from '../styledTable/styledTableCell';
import AccordianCommonRequests from '../commonRequest/accordianCommonRequest';
import CommonRequests from '../commonRequest/commonRequest';

import CustomizedSnackbars from '../snackbar/snackBar';
import AppConstants from '../../constants/appConstants';
import HotelCardSummary from './hotelCardSummary';

const HotelSummary = (props) => {
    const eventState = useEventState();
    const authState = useAuthState();
    const loading = useState(false);
    const allHotelData = useState();
    const allListData = useState([]);
    const allDataFilterHotel = useState();
    const allDistinctDataFilterHotel = useState();
    const filteredList = useState([]);
    const statusList = useState(REQUEST_STATUS_LIST);
    const [modPermission, setModPermission] = React.useState(null);
    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: null,
        noOfPages: null,
    });
    const [showStatus, setShowStatus] = React.useState({
        Approved: 0,
        Pending: 0,
        Rejected: 0,
    });
    const [participantList, setParticipantList] = React.useState(null);
    const [filters, setFilters] = React.useState(null);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const [filterChangeVal, setFilterChangeVal] = React.useState(false);
    const [isCombine, setIsCombine] = React.useState(true);
    const eventParticipants = useState([]);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });

    const eventInfo = Helper.getStorage('eventInfo');
    const userInfo = Helper.getStorage('userInfo');

    let eventRole = '';
    if (!isEmpty(eventInfo)) {
        eventRole =
            userInfo && userInfo.roles
                ? userInfo.roles.find(
                    (item) => item.eventID === eventInfo.eventID
                )?.eventRole
                : '';
    }

    useEffect(() => {
        getAdminHotelSummaryList();
    }, []);

    useEffect(() => {
        if (
            Helper.isAdminUser(userInfo) ||
            Helper.isEventAdmin(userInfo) ||
            Helper.isEventStaff(userInfo)
        ) {
            setModPermission(FULL_PERMISSION);
        } else {
            setModPermission(VIEW_PERMISSION);
        }
        const authStateInfo = authState
            .nested('appDetails')
            .attach(Downgraded)
            .get();
        if (
            authState &&
            authStateInfo &&
            authStateInfo.itemsPerPage &&
            pagingInfo.get().itemsPerPage == null
        ) {
            pagingInfo.set({
                ...pagingInfo,
                currentPage: 1,
                itemsPerPage: authStateInfo.itemsPerPage,
                noOfPages: null,
            });
        }
    }, [authState]);

    // useEffect(() => {

    //     let isCombine;
    //     if (
    //         eventData.get() &&
    //         eventData.moduleDetails.get() &&
    //         eventData.moduleDetails.get().length > 0
    //     ) {
    //         isCombine = eventData.moduleDetails.get().some((module) =>
    //             module.moduleID === AppConstants.EVENT_MODULES.COMBINE_HOTEL);
    //         setIsCombine(isCombine);
    //     }


    // }, [eventData])

    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        if (eventState && eventState.eventDetail.get()) {
            if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo) || Helper.isEventAdmin(userInfo)) {
                setModPermission(FULL_PERMISSION);
            }
        }
    }, [eventState]);

    useEffect(() => {
        if (
            allHotelData.attach(Downgraded).get() &&
            allHotelData.attach(Downgraded).get().length > 0
        ) {
            const distinctUser = allHotelData
                .attach(Downgraded)
                .get()
                .filter((item, index, self) => {
                    return index === self.findIndex((t) => (
                        t.userID === item.userID
                    ));
                });

            allDataFilterHotel.set(distinctUser)
        }
        else {
            allDataFilterHotel.set([])
        }
    }, [
        allHotelData.attach(Downgraded).get(),
    ]);

    //  useEffect(() => {
    //     if (allHotelData.attach(Downgraded).get() && allHotelData.attach(Downgraded).get().length > 0) {
    //         const distinctUser = allHotelData
    //             .attach(Downgraded)
    //             .get()
    //             .reduce((acc, item) => {
    //                 const existingItem = acc.find(t => t.userID === item.userID);
    //                 if (!existingItem) {
    //                     // If the user doesn't exist in the distinctUser array yet, push a new item
    //                     acc.push({
    //                         ...item,
    //                         row: item.row.map(rowItem => ({
    //                             ...rowItem,
    //                             approvedcount: rowItem.approvedcount,
    //                             pendingcount: rowItem.pendingcount,
    //                         }))
    //                     });
    //                 } else {
    //                     // If the user already exists in the distinctUser array, update counts
    //                     item.row.forEach(rowItem => {
    //                             existingItem.row.forEach(existingRowItem => {
    //                                 if (existingRowItem.key === 'waitlist') {
    //                                     existingRowItem.approvedcount += rowItem.approvedcount
    //                                     existingRowItem.pendingcount += rowItem.pendingcount
    //                                 }
    //                             });
    //                     });
    //                 }
    //                 return acc;
    //             }, []);

    //         allDistinctDataFilterHotel.set(distinctUser);
    //     }
    // }, [allHotelData.attach(Downgraded).get()]);

    const getAdminHotelSummaryList = () => {
        let participantList = [];
        const userInfo = Helper.getStorage('userInfo');
        const eventInfo = Helper.getStorage('eventInfo');
        loading.set(true);
        let url = ''
        if (props.data[0].module === AppConstants.EVENT_MODULES.COMBINE_HOTEL) {
            url = APIURLConstants.GET_COMBINE_HOTELBOOKING_LIST;
        }
        else if (props.data[0].module === AppConstants.EVENT_MODULES.DRAFT_HOTEL) {
            url = APIURLConstants.GET_DRAFT_HOTELBOOKING_LIST;
        }
        ApiHelper.get(
            url(
                eventInfo.eventID,
                userInfo.userID,
                userInfo.userType == 'Admin' || !isEmpty(eventRole)
                    ? true
                    : false,
                false,
                1,
                5000
            )
        )
            .then((res) => {
                if (res.data.rows) {
                    let data = res.data.rows;
                    let requestData = [];
                    if (data.length > 0) {
                        let approved = 0;
                        let pending = 0;
                        let rejected = 0;
                        const indexOfLastRecord =
                            pagingInfo.get().currentPage *
                            pagingInfo.get().itemsPerPage;
                        const indexOfFirstRecord =
                            indexOfLastRecord - pagingInfo.get().itemsPerPage;
                        data.map((item) => {
                            if (item.requestStatus === 'Approved') {
                                approved += 1;
                            } else if (item.requestStatus === 'Pending') {
                                pending += 1;
                            } else {
                                rejected += 1;
                            }
                            if (
                                participantList.indexOf(item.participant) == -1
                            ) {
                                participantList.push(item.participant);
                            }
                            let hotelSettingData = [];
                            let hotelSettingRemainingcount = [];
                            if (
                                item.hotelAllStarSettings !== undefined &&
                                item.hotelAllStarSettings.length > 0
                            ) {
                                const parseData = JSON.parse(
                                    item.hotelAllStarSettings[0].setting
                                );
                                if (
                                    parseData !== undefined &&
                                    parseData.length > 0
                                ) {
                                    const settingParseData = parseData[0].HotelSetting ? JSON.parse(
                                        parseData[0].HotelSetting
                                    ) : null;
                                    hotelSettingData.push(settingParseData);
                                    hotelSettingRemainingcount.push({
                                        comp:
                                            // Number(settingParseData.comp) -
                                            Number(
                                                item.hotelAllStarSettings[0]
                                                    .actualCompCount
                                            ),
                                        pay:
                                            // Number(settingParseData.pay) -
                                            Number(
                                                item.hotelAllStarSettings[0]
                                                    .actualPayCount
                                            ),
                                    });
                                }
                            }

                            requestData.push({
                                actualData: item,
                                userID: item.addedFor,
                                participant: item.participant,
                                row: [
                                    {
                                        label: 'Participant',
                                        key: 'participant',
                                        participant: item.participant,
                                        width: '0.35',
                                        showLabel: false,
                                        toEmail: item.email,
                                        showEmail: true,
                                    },
                                    {
                                        label: 'Complimentary',
                                        key: 'Complimentary',
                                        hotelSettingData:
                                            hotelSettingData.length > 0
                                                ? hotelSettingData
                                                : 0,
                                        hotelSettingRemainingcount:
                                            hotelSettingRemainingcount.length >
                                                0
                                                ? hotelSettingRemainingcount
                                                : 0,
                                        allotment:
                                            hotelSettingData.length > 0
                                                ? hotelSettingData[0].comp +
                                                '/' +
                                                hotelSettingData[0].comp
                                                : 0,
                                        showLabel: false,
                                        width: '0.25',
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'For Purchase',
                                        key: 'forpurchase',
                                        hotelSettingData:
                                            hotelSettingData.length > 0
                                                ? hotelSettingData
                                                : 0,
                                        hotelSettingRemainingcount:
                                            hotelSettingRemainingcount.length >
                                                0
                                                ? hotelSettingRemainingcount
                                                : 0,
                                        allotment:
                                            hotelSettingData.length > 0
                                                ? hotelSettingData[0].pay +
                                                '/' +
                                                hotelSettingData[0].pay
                                                : 0,
                                        showLabel: false,
                                        width: '0.20',
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Waitlist Request',
                                        key: 'waitlist',
                                        approvedcount: item.hotelAllStarSettings.length > 0 ?
                                            item.hotelAllStarSettings[0].waitlistApprovedCount :
                                            0,
                                        pendingcount: item.hotelAllStarSettings.length > 0 ?
                                            item.hotelAllStarSettings[0].waitlistPendingCount :
                                            0,
                                        showLabel: false,
                                        width: '0.20',
                                        alignCenter: true,
                                    },
                                    // {
                                    //     label: 'Status',
                                    //     key: 'requestStatus',
                                    //     requestStatus: item.requestStatus,
                                    //     width: '0.15',
                                    //     showStatusIcon: true,
                                    //     inColumn: true,
                                    //     alignCenter: true,
                                    // },
                                ],
                                selected: false,
                            });
                        });
                        setShowStatus({
                            Approved: approved,
                            Pending: pending,
                            Rejected: rejected,
                        });
                    } else {
                        setShowStatus({ Approved: 0, Pending: 0, Rejected: 0 });
                    }
                    setShowSearchRec(false);
                    let filterData = filteredList.attach(Downgraded).get();
                    if (filterData.length > 0) {
                        setFilterChangeVal(true);
                    }
                    allHotelData.set(requestData);
                    allListData.set(requestData);

                    setFilters({
                        participant: participantList,
                        requestStatus: statusList.attach(Downgraded).get(),
                    });
                    loading.set(false);

                    if (pagingInfo.get().noOfPages == null) {
                        pagingInfo.set({
                            ...pagingInfo,
                            currentPage: pagingInfo.get().currentPage,
                            itemsPerPage: pagingInfo.get().itemsPerPage,
                            noOfPages: Math.ceil(
                                res.data.totalCount /
                                pagingInfo.get().itemsPerPage
                            ),
                        });
                    }
                }
            })
            .catch((error) => {
                loading.set(false);
                if (error.response && error.response.status === 401) {
                    alert(error);
                }
            });
    };

    return (
        <Box sx={{
            width: '100%',
            overflow: 'auto',
            height: `calc(100vh -  196px)`
        }}>
            {loading.get() && loading.get() ? (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        width: '100%',
                        mx: 'auto',
                    }}>
                    <CircularProgress />
                </Box>
            ) : (
                <Box component="div" sx={{ display: 'flex', flexDirection: 'column' }}>
                    {
                        <HotelCardSummary
                            filterdata={allDataFilterHotel.attach(Downgraded).get() ? allDataFilterHotel.attach(Downgraded).get() : []}
                            data={allHotelData.attach(Downgraded).get() ? allHotelData.attach(Downgraded).get() : []}

                        />
                    }
                    {/* <Box
                        component="div"
                        sx={{
                            width: '20%',
                            padding: '0 8px',
                            display: 'flex',
                        }}>
                        <UserList
                            participants={userList.attach(Downgraded).get()}
                            handleUserClick={handleUserClick}
                            listSelect={onListSelect}
                            selectAll={onListSelectAll}
                            // allSelect={selectAllFlag ? true : false}
                            selected={selectedUser}
                        />
                    </Box> */}

                    <Box
                        component="div"
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                        }}>

                        <CommonRequests
                            // new props
                            data={allDataFilterHotel.attach(Downgraded).get()}
                            //editRow={redirectToEditRequest}
                            // handleClick={onAddRequest}
                            hideEdit={true}
                            title={''}
                            // deleteRows={onDelete}
                            showSearch={true}
                            searchLabel={'Search'}
                            showFilter={false}
                            filters={filters}
                            showSearchRec={showSearchRec}
                            setShowSearchRec={setShowSearchRec}
                            // onActionClick={onActionClick}
                            // showHistory={showHotelHistory}
                            // showExport={true}
                            // callExport={callExport}
                            // getResults={getAdminHotelRequestList}
                            pagingInfo={pagingInfo.attach(Downgraded).get()}
                            // handlePageChange={handlePageChange}
                            snackBarProps={snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            // onPendingAction={onPendingAction}
                            modPermission={modPermission}
                            // filterListData={filterListData}
                            //moduleToShow={''}
                            //moduleDisplayName={Helper.getModuleName(eventData.get() ? eventData.moduleDetails.get() : [],AppConstants.EVENT_MODULES.COMBINE_HOTEL)}
                            filterChangeVal={filterChangeVal}
                            // showSelectedUser={selectedUserName}
                            // loading={loading.get()}
                            hideToolBar={true}
                            showMenuAdd={false}
                            hideAdd={true}
                            hideDelete={true}
                            hideSelectAll={true}
                            show={showStatus}
                            hideReject={true}
                            hideApprove={true}
                            showExpandCollapseValue={false}
                            setAutoHeight={true}
                            hideModuleInfo={true}
                        />
                    </Box>
                </Box>
            )}

            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
        </Box>
    );
};

export default HotelSummary;
